const ServiceCard = ({ service }) => {
  return (
    <div className=" max-w-[360px] flex flex-col items-center text-center p-2 border-2  border-accent/10 rounded-lg bg-accent/[0.03] ">
      <div className="w-24 h-24 flex flex-col items-center justify-center transition-all rounded-full hover:bg-accent/30">
        <service.icon fontSize={50} className="text-accent" />
      </div>
      <h1 className="text-2xl font-semibold capitalize text-white/90 mt-8 mb-4">
        {service?.title}
      </h1>
      <p>{service?.desc}</p>
    </div>
  );
};

export default ServiceCard;
